module.exports = __webpack_public_path__ + "static/media/radar-logo.5dd36ba3.png";